import {
  Directive,
  HostListener
} from '@angular/core';

import { SessionService } from '../../../sessions/session.service';

// Remembers the current page on click, so the page it opens can return here with SessionService.routeTo().
@Directive({
  selector: '[worSaveRoute]'
})
export class SaveRouteDirective {
  constructor (
    private sessionService : SessionService
  ) {}

  @HostListener('click')
  onClick () : void {
    this.sessionService.saveRoute();
  }
}
